import { render, staticRenderFns } from "./CDurationPicker.vue?vue&type=template&id=faf78530&scoped=true"
import script from "./CDurationPicker.vue?vue&type=script&lang=js"
export * from "./CDurationPicker.vue?vue&type=script&lang=js"
import style0 from "./CDurationPicker.vue?vue&type=style&index=0&id=faf78530&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf78530",
  null
  
)

export default component.exports